export default __webpack_public_path__ + "static/media/wojak.df6a668d.jpg";